import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardActions,
  Box,
} from "@mui/material";
import { LocalFireDepartment } from "@mui/icons-material";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "./component.css";
import loadingGif from '../pages/CMD/loading.gif';
import parse from 'html-react-parser'; // Importing the html-react-parser library

const Protifile = ({ mode }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true); // Added loading state

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get("https://sirius.runasp.net/api/Project");
        setProjects(response.data);
      } catch (error) {
        console.error("Error fetching the projects", error);
      } finally {
        setLoading(false); // Set loading to false after data is fetched or error occurs
      }
    };

    fetchProjects();
  }, []);

  const truncateText = (text, limit) => {
    const words = text.split(" ");
    return words.length > limit
      ? words.slice(0, limit).join(" ") + "..."
      : text;
  };

  if (loading) {
    return (
      <div style={{ margin:'50px auto', textAlign:'center',  width:'200px',height:'200px' }}>
        <img width={'100%'} src={loadingGif} alt="Loading..."  />
      </div>
    );
  }

  const settings = (photoCount) => ({
    dots: photoCount > 1,
    infinite: photoCount > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: dots => (
      <div style={{ padding: '1rem' }}>
        <ul style={{ margin: '-15px 0', padding: '1rem' }}> {dots} </ul>
      </div>
    ),
    customPaging: i => (
      <div
        className="custom-dot"
        style={{
          width: '10px',
          height: '10px',
          background: 'lightcoral',
          borderRadius: '50%',
          display: 'inline-block',
          margin: '-30px 5px',
        }}
      />
    ),
    arrows: false
  });

  return (
    <Box component="section" py={6} padding={"2rem"} bgcolor="background.paper">
      <Grid container spacing={3} data-aos="fade-up">
        {projects.map((project) => (
          <Grid item xs={12} sm={6} md={4} key={project.id}>
            <Card
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                border: '1px solid',
                borderColor: mode === 'dark' ? 'lightcoral' : 'silver'
              }}
            >
              <Slider {...settings(project.photos.length)}>
                {project.photos.map((photo, index) => (
                  <div key={index} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <img
                      src={`https://sirius.runasp.net/${photo.filePath}`}
                      alt={`Project ${project.id} ${index}`}
                      style={{
                        width: "100%",
                        height: "300px",
                        objectFit: "cover",
                        objectPosition: 'center',
                        borderRadius: "8px",
                      }}
                    />
                  </div>
                ))}
              </Slider>
              <CardContent>
                <Typography variant="h5" component="div" sx={{marginTop:'15px'}}>
                  {project.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {parse(truncateText(project.description, 40))} {/* Limiting the description to 40 words */}
                </Typography>
              </CardContent>
              <CardActions sx={{ mt: "auto" }}>
                <Link
                  to={`/portfolio/${project.id}`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "5px",
                    padding: "10px",
                    textDecoration: "none",
                    color: "#fff",
                    backgroundColor: "#e84545",
                  }}
                >
                  <LocalFireDepartment />
                  Learn More
                </Link>
              </CardActions>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Protifile;
